import { COURSE_API } from '@/courses/values/courses.values';
import { RequestProvider } from '@/shared/providers/request.provider';
import Vue from 'vue';

class ComponentActions {

  createComponent(ctx, payload) {
    const req = COURSE_API.CREATE_EDUAC_COMPONENT;
    return new Promise((resolve, reject) => {
      RequestProvider.post(req, payload.data)
      .then((res: any) => {
        Vue.prototype.$Courses.Store.addComponent({
          data: res,
          courseId: payload.courseId,
          classId: payload.classId
        });
        resolve(res.id);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  updateComponent(ctx, payload): Promise<void> {
    const req = COURSE_API.UPDATE_EDUAC_COMPONENT;
    return new Promise((resolve, reject) => {
      RequestProvider.put(req , payload.data)
        .then(() => {
          Vue.prototype.$Courses.Store.setComponent(payload);
          resolve();
        }).catch((err) => {
          reject(err.response);
        });
    });
  }

  removeComponent(ctx, payload): Promise<void> {
    const req = COURSE_API.REMOVE_EDUAC_COMPONENT
      .replace('{componentId}', String(payload.componentId));
    return new Promise((resolve, reject) => {
      RequestProvider.remove(req)
      .then(() => {
        Vue.prototype.$Courses.Store.deleteComponent(payload);
        resolve();
      }).catch((err) => {
        reject(err);
      });
    })
  }

}

export default new ComponentActions();